import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { YoneticiLayout } from './components/layout/YoneticiLayout';
import { YoneticiDashboard } from './components/dashboard/YoneticiDashboard';
import { YoneticiEtkinlikler } from './components/pages/YoneticiEtkinlikler';
import { YoneticiMesajlar } from './components/pages/YoneticiMesajlar';
import { OgrenciYonetimi } from './components/pages/OgrenciYonetimi';
import { OgretmenYonetimi } from './components/pages/OgretmenYonetimi';
import { SinifYonetimi } from './components/pages/SinifYonetimi';
import { RaporlarAnalizler } from './components/pages/RaporlarAnalizler';
import { DuyuruYonetimi } from './components/pages/DuyuruYonetimi';
import { YoneticiProfil } from './components/pages/YoneticiProfil';
import { FaturaGecmisi } from './components/pages/FaturaGecmisi';
import { Forum } from './components/pages/Forum'; // ← YENİ EKLEME
import { PlaceholderPage } from './components/pages/PlaceholderPage';
import { NotificationHistory } from './components/pages/NotificationHistory';
import { NotificationSettings } from './components/pages/NotificationSettings';
import { MessageSquare, Users, UserCheck, BookCopy, Megaphone, BarChart, Bell } from 'lucide-react';
export function AppRouter() {
  return <BrowserRouter data-id="element-7">
      <Routes data-id="element-8">
        <Route path="/" element={<App data-id="element-10" />} data-id="element-9" />
        <Route path="/yonetici" element={<YoneticiLayout data-id="element-12" />} data-id="element-11">
          <Route index element={<YoneticiDashboard data-id="element-14" />} data-id="element-13" />
          <Route path="etkinlikler" element={<YoneticiEtkinlikler data-id="element-16" />} data-id="element-15" />
          <Route path="mesajlar" element={<YoneticiMesajlar data-id="element-18" />} data-id="element-17" />
          <Route path="ogrenciler" element={<OgrenciYonetimi data-id="element-20" />} data-id="element-19" />
          <Route path="ogretmenler" element={<OgretmenYonetimi data-id="element-22" />} data-id="element-21" />
          <Route path="siniflar" element={<SinifYonetimi data-id="element-24" />} data-id="element-23" />
          <Route path="siniflar/:id" element={<SinifYonetimi data-id="element-26" />} data-id="element-25" />
          <Route path="raporlar" element={<RaporlarAnalizler data-id="element-28" />} data-id="element-27" />
          <Route path="duyurular" element={<DuyuruYonetimi data-id="element-30" />} data-id="element-29" />
          <Route path="forum" element={<Forum data-id="element-32" />} data-id="element-31" />
          <Route path="bildirimler" element={<NotificationHistory data-id="element-34" />} data-id="element-33" />
          <Route path="bildirim-ayarlari" element={<NotificationSettings data-id="element-36" />} data-id="element-35" />
          <Route path="bildirimler-eski" element={<PlaceholderPage title="Bildirimler" icon={<Bell className="w-8 h-8 text-orange-400" data-id="element-39" />} data-id="element-38" />} data-id="element-37" />
          <Route path="profil" element={<YoneticiProfil data-id="element-41" />} data-id="element-40" />
        </Route>
        <Route path="/fatura-gecmisi" element={<FaturaGecmisi data-id="element-43" />} data-id="element-42" />
      </Routes>
    </BrowserRouter>;
}